import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { DUELESS_BLOCK_NAME, DUELESS_COLOR, DUEMORE_BLOCK_NAME, 
  DUEMORE_COLOR, OVERDUE_BLOCK_NAME, OVERDUE_COLOR, PHIX_BLOCK_NAME, PHIX_COLOR } from '../runplan-mainview/models/runPlanConstants';
import { ErrorHandler } from '../utils/error-handler';
import { RunplanSchedulerService } from './runplan-scheduler.service';
import { ConfirmationService } from 'primeng/api';
import { Paginator } from 'primeng/paginator';


@Component({
  selector: 'app-runplan-scheduler',
  templateUrl: './runplan-scheduler.component.html',
  styleUrls: ['./runplan-scheduler.component.css']
})

export class RunplanSchedulerComponent implements OnInit {

  errorHandler: ErrorHandler = new ErrorHandler;
  selectableLab: any;
  sequencerOptions:any[] = [];
  selectedSequencerType: string = null;
  flowCellDurationMap: Map<string, any> = new Map();

  unscheduledSkip: number;
  unscheduledLimit: number;
  unscheduledTotal: number;
  unscheduledTableData: any[] = [];
  unscheduledTableDataDuplicate: any[] = [];
  unscheduledTableLoading: boolean = false;
  unscheduledTableColumns: any[] = [];
  unscheduledTableRunLaneMap: Map<string, any[]> = new Map();
  unscheduledTableScrollheight = '35vh';

  scheduledSkip: number;
  scheduledLimit: number;
  scheduledTotal: number;
  scheduledTableData: any[] = [];
  scheduledTableDataDuplicate: any[] = [];
  scheduledFromDate: Date;
  scheduledToDate: Date;
  scheduledTableLoading: boolean = false;
  scheduledTableColumns: any[] = [];
  scheduledTableRunLaneMap: Map<string, any[]> = new Map();
  scheduledTableScrollheight = '28.8vh';
  showScheduleSideBar = false;
  
  scheduleMatrix: any[] = [];
  scheduleDateList:string[] = [];

  colorMap: Map<number, any> = new Map<number, any>();
  schedulingBlock = false;
  headerVal = [1];
  machines: string[] = [];
  runIdToBeScheduled: string;

  sequencers: any[] = [];
  selectedSequencer: string = null;
  selectedSequencerBackup: string = null;
  selectedRunDuration: number = 0;
  runPlans: any = null;
  selectedTimeSlotStart: Date = null;
  selectedTimeSlotStartBackup: Date = null;
  selectedTimeSlotEnd: Date = null;
  selectedTimeSlotEndBackup: Date = null;
  minDate: Date = null;
  maxDate: Date = null;
  schedulingMessage: string = '';
  showSlotErrorMessage: boolean = false;
  slotValidated = false;
  selectedRun: any = null;
  puid: string;
  unscheduleRunId: string;
  unschduledfiltervalue: any;
  schduledfiltervalue: any;
  pageNumber: number;
  pageLimit: number;
  pageSkip: number = 0;
  
  schduledpageNumber: number;
  readonly SCHEDULED_TABLE_FILTER_STATUS =  ['SEQ_RUN_STARTED', 'RUN_SCHEDULED', 'PREPARE_DATA_FOR_ANALYSIS', 'SEQ_RUN_FINISHED', 'PA_STARTED', 'PA_FINISHED', 'RUN_REVIEW_STARTED', 'COMPLETED',"DP_STARTED",
  "DP_COMPLETED", "READY_FOR_RUNQC", "MANUAL_RUNQC_STARTED", "MANUAL_RUNQC_FINISHED"]

  readonly STATUS_FILTERED_ON_PLANNED_DATE = ['RUN_SCHEDULED', 'PREPARE_DATA_FOR_ANALYSIS',"DP_STARTED", "DP_COMPLETED"]

  schduledpageLimit: number;
  schduledpageSkip: number = 0;

  @ViewChild('unschduledPP',{static : false}) unSchdulepaginator: Paginator;
  @ViewChild('schduledPP',{static : false}) schdulepaginator: Paginator;
  dateFormat: any;

  constructor(private runPlanSchedulerService: RunplanSchedulerService, private _messagesService: MessagesService, 
    private datepipe: DatePipe, private masterDataMDMService: MasterDataService,  private confirmationService: ConfirmationService) { }

    setDateFormat(dateFormat){
      return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
    }

  ngOnInit() {
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.getSequencerFromMachine();
    this.puid = localStorage.getItem('PUID');
    this.unscheduledSkip = 0;
    this.unscheduledLimit = 40;
    this.unscheduledTotal = 40;
    this.dateFormat =this.setDateFormat(this.selectableLab.lab.dateFormat.toLowerCase());
    this.unscheduledTableLoading = false;
    this.unscheduledTableColumns = [
      {'header': 'Run ID', 'field': 'runId', 'width' : '5%' },
      {'header': 'Flowcell Config', 'field': 'flowcellConfig', 'width': '15%' },
      {'header': 'Constraints', 'field': 'laneConstraints', 'width': '15%' },
      {'header': 'Raw Data Due Date', 'field': 'laneDetails', 'width' : '35%' },
      {'header': 'Duration', 'field': 'runDuration', 'width' : '10%' },
      {'header': 'Status', 'field': 'status', 'width' : '10%' },
      {'header': 'Action', 'field': 'action', 'width' : '10%' }
    ];

    this.scheduledSkip = 0;
    this.scheduledLimit = 40;
    this.scheduledTotal = 40;
    this.scheduledFromDate = this.getDefaultDate(new Date(), -3);
    this.scheduledToDate = this.getDefaultDate(new Date(), +9);
    this.scheduledTableLoading = false;
    this.scheduledTableColumns = [
      {'header': 'Run ID', 'field': 'runId', 'width' : '5%' },
      {'header': 'Flowcell Config', 'field': 'flowcellConfig', 'width' : '10%' },
      {'header': 'Constraints', 'field': 'laneConstraints', 'selected': '10%' },
      {'header': 'Raw Data Due Date', 'field': 'laneDetails', 'width' : '20%'},
      {'header': 'Sequencer', 'field': 'sequencerIntrument', 'width' : '10%'},
      {'header': 'Start', 'field': 'planDate', 'width' : '10%'},
      {'header': 'Finish', 'field': 'plannedFinishDate', 'width' : '10%'},
      {'header': 'Status', 'field': 'status', 'width' : '10%' },
      {'header': 'Action', 'field': 'action', 'width' : '5%'}
    ];

    this.colorMap.set(0, {'background-color':'#6aa84f', 'border' : '1px solid black', 'cursor': 'pointer'});
    this.colorMap.set(1, {'background-color':'#fdb872', 'border' : '1px solid black', 'cursor': 'pointer'});
    this.colorMap.set(2, {'background-color':'#e97474', 'border' : '1px solid black', 'cursor': 'pointer'});
  }
  
  

  getSequencerFromMachine(){
    this.runPlanSchedulerService.getSequencerMachines("Artic NGS").subscribe(
      result => {
        let sequenceData = result.data;
        sequenceData.forEach(seqName => {
          this.sequencerOptions.push({ label: seqName.name, value: seqName.name });
        });
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }

  getDataFromBackEnd() {
    this.scheduledFromDate = this.getDefaultDate(new Date(), -3);
    this.scheduledToDate = this.getDefaultDate(new Date(), +9);
    this.getFlowCellMap();
    this.getMachinesForType();
    this.getUnscheduledTableData();
    this.getScheduledTableData();
  }
  getMachinesForType() {
    this.masterDataMDMService.getNamesForMachinesWithTypes(this.selectedSequencerType, this.selectableLab.lab._id, true).subscribe(
      results=>{
        this.machines = results.data;
      },error=>{
        this.machines = [];
        this.errorHandlerMethod(error);
      }
    )
  }

  refreshViews() {
    this.unschduledfiltervalue = null;
    this.schduledfiltervalue  = null;
    this.getUnscheduledTableData();
    this.getScheduledTableData();
  }

  getFlowCellMap(){
    this.flowCellDurationMap = new Map<string, any>(); 
    this.runPlanSchedulerService.getFlowcellCapacity(this.selectableLab.lab._id, this.selectedSequencerType).subscribe(
      result => {
        if(result.data && result.data.flowCellDurationMap) {
          this.flowCellDurationMap =  new Map(Object.entries(result.data.flowCellDurationMap));
        }
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }
  getUnscheduledTableData() {
    this.unSchdulepaginator.first=0;
    this.pageNumber = 1;
    this.pageLimit  = 40;
    let request = {
      'lab': this.selectableLab.lab._id,
      'statusList': ['RUN_PLANNED'],
      'sequencerType': this.selectedSequencerType,
      'page': this.pageNumber,
      'skip': 0,
      'limit': this.pageLimit
    }
    this.getUnscheduledAPiCall(request);
  }
  getUnscheduledAPiCall(request:any) {
    this.unscheduledTableLoading = true;
    this.unscheduledTableData = [];
    this.unscheduledTableRunLaneMap = new Map();
    this.runPlanSchedulerService.getUnscheduledRuns(request).subscribe(
      result => {
        if(result && result.data && result.data.data && result.data.metadata && result.data.metadata.total) {
          this.unscheduledTotal = result.data.metadata.total;
          this.unscheduledTableData = result.data.data.data;
          this.unscheduledTableDataDuplicate = result.data.data.data;
          this.unscheduledTableRunLaneMap = this.constructRunLaneMap(this.unscheduledTableData);
          if (this.unschduledfiltervalue) {
            this.unScheduleGlobalFilter(this.unschduledfiltervalue);
          }
        } else {
          this.unscheduledTotal = 0;
          this.unscheduledTableData = []; 
          this.unscheduledTableDataDuplicate = [];
        }
        this.unscheduleRunId = null;
        this.unscheduledTableLoading = false;
      },
      error => {
        this.unscheduledTableLoading = false;
        this.errorHandlerMethod(error);
      }
    );
  }
  getScheduledTableData() {
    this.schdulepaginator.first=0;
    this.schduledpageNumber = 1;
    this.schduledpageLimit  = 40;
    let request = {
      'lab': this.selectableLab.lab._id,
      'statusList': this.SCHEDULED_TABLE_FILTER_STATUS,
      'sequencerType': this.selectedSequencerType,
      'page': this.schduledpageNumber,
      'skip': 0,
      'limit': this.schduledpageLimit,
      'startDate': this.scheduledFromDate.toISOString(),
      'finishDate': this.scheduledToDate.toISOString()
    };
    this.getscheduledAPiCall(request);
  }
  getscheduledAPiCall(request: any) {
    if(this.scheduledFromDate > this.scheduledToDate) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'From date cannot be greater than To date'});
      return;
    }
    this.scheduledTableLoading = true;
    this.scheduledTableData = [];
    this.scheduledTableRunLaneMap = new Map();
    this.runPlanSchedulerService.getScheduledRuns(request).subscribe(
      result => {
        if(result && result.data &&  result.data.data && result.data.metadata && result.data.metadata.total) {
          this.scheduledTotal = result.data.metadata.total;
          this.scheduledTableData = result.data.data.data;
          this.scheduledTableDataDuplicate = result.data.data.data;
          this.scheduledTableRunLaneMap = this.constructRunLaneMap(this.scheduledTableData);
          if (this.schduledfiltervalue) {
            this.scheduleGlobalFilter(this.schduledfiltervalue);
          }
        } else {
          this.scheduledTotal = 0;
          this.scheduledTableData = []; 
          this.scheduledTableDataDuplicate =[];
        }
        this.scheduledTableLoading = false;
      },
      error => {
        this.scheduledTableLoading = false;
        this.errorHandlerMethod(error);
      }
    );
  }

  getRunStartDate(rowData){
    if(this.STATUS_FILTERED_ON_PLANNED_DATE.includes(rowData['status'])){
      return this.getDate(rowData['planDate']);
    }else{
      return this.getDate(rowData['actualStartDate']);
    }
  }

  getRunFinishDate(rowData){
    if(this.STATUS_FILTERED_ON_PLANNED_DATE.includes(rowData['status'])){
      return this.getDate(rowData['plannedFinishDate']);
    }else{
      return this.getDate(rowData['actualFinishDate']);
    }
  }

  errorHandlerMethod(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getDefaultDate(date: Date, delta: number) {
    date.setDate(date.getDate() + delta);
    return date;
  }

  getRunDuration(flowcellName: string, largestReadMode: string) {
    let flowCellMap = this.flowCellDurationMap.get(flowcellName);
    let duration = flowCellMap ? flowCellMap[largestReadMode] : null;
    return duration ? duration + ' hrs' : null;
  }

  constructRunLaneMap(runTableData: any[]) {
    if(!runTableData || runTableData.length == 0) {
      return;
    }

    let runLaneMap = new Map();
    runTableData.forEach(run => {
      run.runLanes.sort((runLane1: any, runLane2: any) => {
        if(runLane1.laneId > runLane2.laneId) {
          return 1;
        } else if(runLane1.laneId < runLane2.laneId) {
          return -1;
        } else {
          return 0;
        }
      });

      let lanes = [];
      run.runLanes.forEach(lane => {
        let insertingLane = {};
        insertingLane['laneId'] = lane['laneId'];
        insertingLane['constraintId'] = this.getConstraintId(lane['runLanes']);
        insertingLane['laneBlocks'] = this.getLaneBlocks(insertingLane['constraintId'], lane['runLanes']);
        insertingLane['libraryIds'] = this.getAllLibraryIds(insertingLane['laneBlocks']);
        lanes.push(insertingLane);
      });

      runLaneMap.set(run['runId'], lanes);
    });

    return runLaneMap;
  }

  getConstraintId(runLanes: any[]) {
    if(runLanes && (runLanes.length > 0)) {
      return ((runLanes[0]['constratintType'] == 'independent') || (runLanes[0]['constratintType'] == 'batch')) ? 'no' : runLanes[0]['constraintId'];
    } else {
      return '';
    }
  }

  getLaneBlocks(constraintId: string, runLanes: any[]) {
    if(constraintId == '') {
      return [{'color': 'white', 'name' : '', 'weight': 0, 'width' : '0%', 'libraryIds':[]}];
    }
    let remainingCapacity = runLanes[runLanes.length - 1]['remainingCapacity'] ? runLanes[runLanes.length - 1]['remainingCapacity'] : 0;
    let phixBlock = {
      'color' : PHIX_COLOR,
      'name' : PHIX_BLOCK_NAME,
      'weight': runLanes[0]['occupiedCapacity'] ? runLanes[0]['occupiedCapacity'] : 0,
      'width' : runLanes[0]['phiXPercentage'] ?  runLanes[0]['phiXPercentage'] + '%' : '0%',
      'libraryIds' : []
    };

    let overDueBlock = {
      'color' : OVERDUE_COLOR,
      'name' : OVERDUE_BLOCK_NAME,
      'weight' : 0,
      'libraryIds' : []
    };

    let dueLessBlock = {
      'color' : DUELESS_COLOR,
      'name' : DUELESS_BLOCK_NAME,
      'weight' : 0,
      'libraryIds' : []
    };

    let dueMoreBlock = {
      'color' : DUEMORE_COLOR,
      'name' : DUEMORE_BLOCK_NAME,
      'weight' : 0,
      'libraryIds' : []
    };

    runLanes.forEach(ipu => {
      if(ipu['dueDate'] < 2) {
        overDueBlock['weight'] += ipu['weight'];
        overDueBlock['libraryIds'] = overDueBlock['libraryIds'].concat(ipu['libraryId']); 
      } else if(ipu['dueDate'] >= 2 && ipu['dueDate'] <= 5) {
        dueLessBlock['weight'] += ipu['weight'];
        dueLessBlock['libraryIds'] = dueLessBlock['libraryIds'].concat(ipu['libraryId']);
      } else {
        dueMoreBlock['weight'] += ipu['weight'];
        dueMoreBlock['libraryIds'] = dueMoreBlock['libraryIds'].concat(ipu['libraryId']);
      }
    });

    let totalLaneCapacity = phixBlock['weight'] + overDueBlock['weight'] + dueLessBlock['weight'] + dueMoreBlock['weight'] + remainingCapacity;
  
    overDueBlock['width'] = (Math.round(((overDueBlock['weight'] / totalLaneCapacity) * 100) * 100) / 100) + '%';
    dueLessBlock['width'] = (Math.round(((dueLessBlock['weight'] / totalLaneCapacity) * 100) * 100) / 100) + '%';
    dueMoreBlock['width'] = (Math.round(((dueMoreBlock['weight'] / totalLaneCapacity) * 100) * 100) / 100) + '%';

    return [phixBlock, overDueBlock, dueLessBlock, dueMoreBlock];
  }

  getAllLibraryIds(laneBlocks: any[]) {
    let libraryIds = [];
    laneBlocks.forEach(block => {
      libraryIds = libraryIds.concat(block['libraryIds']);
    });

    return libraryIds;
  }

  getDate(date: any) {
    if(date) {
      return this.datepipe.transform(date['$date'], this.selectableLab.lab.dateTimeFormat);
    }
    return null;
  }

  getLanesForUnscheduled(runId: string) {
    return this.unscheduledTableRunLaneMap.get(runId);
  }

  getLanesForScheduled(runId: string) {
    return this.scheduledTableRunLaneMap.get(runId);
  }

  getLaneBlockStyle(laneBlock: any) {
    return {
      'width': laneBlock['width'],
      'background-color': laneBlock['color'], 
      'height': '2rem'
    }
  }


  unscheduleRun(run:any){
    this.confirmationService.confirm({
      message: 'You have  requested the unscheduling of run ' + run.runId +'. If you confirm to do so, the run will appear in the unscheduled run table and has to be scheduled again.  <br/>Please confirm, if you really want to unschedule this run.',
      header: 'Confirmation',
      accept: () => {
        let request = {
          'lab' : this.selectableLab.lab._id,
          'runId' : run.runId,
          'puid' : this.puid
        };
        this.runPlanSchedulerService.unscheduleRun(request).subscribe(
          result=>{
            this._messagesService.addSuccessMessage({severity:'success', summary:result.data,detail:''});
            run.status = 'RUN_PLANNED'
            this.unscheduledTableData.unshift(run);
            this.unscheduledTableRunLaneMap.set(run.runId, this.scheduledTableRunLaneMap.get(run.runId));
            this.getScheduledTableData();
            this.unscheduleRunId = run.runId;
          },error=>{
            this.errorHandlerMethod(error);
          }
        )
      },
      reject: () => {/* do nothing */}
    });
  }

  getPlanDate(planDate: any) {
    if(planDate) {
      return planDate['$date'] ? planDate['$date'].slice(0, 10) : null;
    }
  }

  getScheduledMatrix(run: any) {
    this.schedulingBlock = true;
    this.showScheduleSideBar = true;
    this.scheduleMatrix = [];
    this.scheduleDateList = [];
    let dateStr = null;
    let beginDate = new Date();
    dateStr = this.datepipe.transform(beginDate, 'yyyy-MM-dd');
    beginDate = new Date(dateStr);
    let endDate = new Date(beginDate);
    endDate.setDate(endDate.getDate() + 14);

    let dateMap = new Map();
    let beginDateCopy = new Date(beginDate);
    this.scheduleDateList.push('machine');
    while(beginDateCopy.getTime() <= endDate.getTime()) {
      let dateString = this.datepipe.transform(beginDateCopy, 'dd-MM-yyyy');
      dateMap.set(dateString, 0);
      this.scheduleDateList.push(dateString);
      beginDateCopy.setDate(beginDateCopy.getDate() + 1);
    }

    this.runPlans = {};
    let currentDay = {};
    this.selectableLab.lab._id,
    this.scheduleMatrix = [];
    this.runPlanSchedulerService.getSchedulePlanToDisplay(this.selectableLab.lab._id, beginDate.toISOString(), endDate.toISOString()).subscribe(
       result => {
        if(result && result.data) {
          if(result.data.plan) {
            this.runPlans = result.data.plan;
          }
          if(result.data.currentDay) {
            currentDay = result.data.currentDay;
          }
        }
        this.scheduleMatrix = this.getRunMapPerMachine(dateMap, this.runPlans, currentDay);
        this.scheduleMatrix.sort((data1, data2) => {
          if(data1.get('machine') > data2.get('machine')) {
            return 1;
          } else if(data1.get('machine') < data2.get('machine')) {
            return -1;
          } else {
            return 0;
          }
        });
        this.scheduleRun(run);
        this.schedulingBlock = false;
       },
       error => {
        this.schedulingBlock = false;
        this.errorHandlerMethod(error);
       }
    );
  }

  getRunMapPerMachine(dateMap: Map<string, number>, machineRuns: any, currentDay: any) {
    let matrix = [];

    if(!this.machines || this.machines.length == 0) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No Machine found for this sequencer. Please check MDM configuration'});
      return matrix;
    }

    this.sequencers = [];
    this.machines.sort();
    this.machines.forEach(machine => {
      this.sequencers.push({label: machine, value: machine});
      let machineMap = new Map<string, any>();
      machineMap = new Map(dateMap);
      machineMap.set('machine', machine);
      let times = machineRuns[machine];
      let timeObj = null;
      if(currentDay && currentDay[machine] && !currentDay[machine]['actualStartDate'] && !currentDay[machine]['actualFinishDate']) {
        timeObj = {
          'planDate': currentDay[machine]['planDate'],
          'plannedFinishDate': currentDay[machine]['plannedFinishDate'] 
        };
      }else if(currentDay && currentDay[machine] && currentDay[machine]['actualStartDate'] && currentDay[machine]['actualFinishDate']){
        timeObj = {
          'planDate': currentDay[machine]['actualStartDate'],
          'plannedFinishDate': currentDay[machine]['actualFinishDate'] 
        };
      }

      if(timeObj) {
        if(!times || times.length == 0) {
          times = [];
        }
        times.push(timeObj);
      }

      if(times && times.length > 0) {
        let runStartDate: Date;
        let runEndDate: Date ;
        times.forEach(run => {
            runStartDate = new Date(run['planDate']['$date']);
            runEndDate = new Date(run['plannedFinishDate']['$date']);
          
          if(runStartDate && runEndDate && (runStartDate.getTime() <= runEndDate.getTime())) {
            let startDateString = this.datepipe.transform(runStartDate, 'dd-MM-yyyy');
            let endDateString = this.datepipe.transform(runEndDate, 'dd-MM-yyyy');
            let difference = runEndDate.getTime() - runStartDate.getTime();
            machineMap.set(startDateString, machineMap.get(startDateString) + this.getStartDateUsageNumber(runStartDate, difference));
            machineMap.set(endDateString, 
                           machineMap.get(endDateString) 
                                      + this.getEndtDateUsageNumber(runEndDate, 
                                                                    this.sameDayStartStopQualifier(startDateString, endDateString, 
                                                                                                   (runStartDate.getHours() > 12)
                                                                    )
                                        )
            );
            runStartDate = new Date(this.datepipe.transform(runStartDate, 'yyyy-MM-dd'));
            runStartDate.setDate(runStartDate.getDate() + 1);
            runEndDate = new Date(this.datepipe.transform(runEndDate, 'yyyy-MM-dd'));
            runEndDate.setDate(runEndDate.getDate() - 1);
            this.resetHourMinSec(runStartDate);
            this.resetHourMinSec(runEndDate);
            while(runStartDate.getTime() <= runEndDate.getTime()) {
              startDateString = this.datepipe.transform(runStartDate, 'dd-MM-yyyy');
              machineMap.set(startDateString, machineMap.get(startDateString) + 2);
              runStartDate.setDate(runStartDate.getDate() + 1);
            }

              run['planDate'] = new Date(run['planDate']['$date']);
              run['plannedFinishDate'] = new Date(run['plannedFinishDate']['$date']);

          }
        });
       

        times.sort((time1: any, time2: any) => {
          if (time1.planDate.getTime() > time2.planDate.getTime()) {
            return 1;
          } else if (time1.planDate.getTime() < time2.planDate.getTime()) {
            return -1;
          } else {
            return 0;
          }
        });

        machineRuns[machine] = Object.assign([], times);
      }
      matrix.push(machineMap);
    });
    return matrix;
  }

  resetHourMinSec( dateToBeUnset:Date){
    dateToBeUnset.setHours(0);
    dateToBeUnset.setMinutes(0);
    dateToBeUnset.setSeconds(0);
    dateToBeUnset.setMilliseconds(0);
  }
  sameDayStartStopQualifier(startDateString: String, endDateString: String, startsOnOrAfter12: boolean) {
    return ((startDateString == endDateString) && startsOnOrAfter12);
  }

  getStartDateUsageNumber(runStartDate: Date, difference: number) {
    if(!runStartDate) {
      return 0;
    }
    let differenceInHours = Math.ceil(difference / (60 * 60 * 1000));
    let startHour = runStartDate.getHours();
    if(startHour < 12) {
      if((startHour + differenceInHours) >= 12) {
        return 2;
      } else {
        return 0;
      }
    } else if(startHour == 12) {
      return 2;
    } else {
      return 1;
    }
  }

  getEndtDateUsageNumber(runEndDate: Date, sameDayStartAfter12: boolean) {
    if(!runEndDate) {
      return 0;
    }
    let endHour = runEndDate.getHours();
    return (endHour < 12) ? 1 : (sameDayStartAfter12 ? 0 : 2);
  }

  scheduleRun(run: any) {
    this.selectedRun = run;
    this.minDate = new Date();
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 14)
    this.runIdToBeScheduled = run.runId;
    this.showSlotErrorMessage = false;
    this.selectedSequencer = null;
    this.selectedTimeSlotStart = null;
    this.selectedTimeSlotEnd = null;
    this.selectedRunDuration = this.getRunDurationHours(run['flowCellName'], run['largestReadMode']);
    if(!this.selectedRunDuration) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No run duration found for this '});
      return;
    }
    let startDateTime = new Date();
    startDateTime.setMinutes(startDateTime.getMinutes() + 5);
    let endDateTime = new Date(startDateTime);
    endDateTime.setHours(endDateTime.getHours() + this.selectedRunDuration);
    this.slotValidated = false;
    this.machines.sort();
    for(let i = 0; i < this.machines.length; i++) {
      let times = this.runPlans[this.machines[i]];
      let returnObj = this.findSlot(times, startDateTime, endDateTime);
      this.slotValidated = returnObj.slotValidated;
      if(this.slotValidated) {
        if(this.selectedTimeSlotStart && this.selectedTimeSlotEnd) {
          if(returnObj.timeSlotStart.getTime() < this.selectedTimeSlotStart.getTime()) {
            this.selectedTimeSlotStart = new Date(returnObj.timeSlotStart);
            this.selectedTimeSlotEnd = new Date(returnObj.timeSlotEnd);
            this.selectedSequencer = this.machines[i];
          }
        } else {
          this.selectedTimeSlotStart = new Date(returnObj.timeSlotStart);
          this.selectedTimeSlotEnd = new Date(returnObj.timeSlotEnd);
          this.selectedSequencer = this.machines[i];
        }

      }
    }

    if(this.selectedTimeSlotStart && this.selectedTimeSlotEnd) {
      this.selectedTimeSlotStartBackup = new Date(this.selectedTimeSlotStart);
      this.selectedTimeSlotEndBackup = new Date(this.selectedTimeSlotEnd);
      this.selectedSequencerBackup = this.selectedSequencer + '';
      this.schedulingMessage = 'This is the earliest timeslot found for this run.';
      this.showSlotErrorMessage = true;
    } else {
      this.schedulingMessage = 'No suitable timeslot found for this run in the next 15 days.'
      this.showSlotErrorMessage = true;
      return;
    }
  }

  findSlot(times: any[], timeSlotStart: Date, timeSlotEnd: Date) {
    let validSlot = false;
    if(times && times.length > 0) {
      let start : Date;
      let end : Date;
      for(let j = 0; j < times.length; j++) {
       
          start = new Date(times[j]['planDate']);
          end = new Date(times[j]['plannedFinishDate']);
      
        if(this.isInsideThisPlan(timeSlotStart, start, end) || this.isInsideThisPlan(timeSlotEnd, start, end) 
                      || this.planContainsPlan(timeSlotStart, timeSlotEnd, start, end)) {
          timeSlotStart = new Date(end);
          timeSlotStart.setMinutes(timeSlotStart.getMinutes() + 5);
          timeSlotEnd = new Date(timeSlotStart);
          timeSlotEnd.setHours(timeSlotEnd.getHours() + this.selectedRunDuration);
        } 
      }
    } else {
      validSlot = true;
    }
    
    validSlot = !this.isStartDateBeyond15days(timeSlotStart);
    let returnObj = {
      slotValidated : validSlot,
      timeSlotStart : timeSlotStart,
      timeSlotEnd : timeSlotEnd
    }
    return returnObj;
  }

  isStartDateBeyond15days(date: Date) {
    let todayStr = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    let invalidDay = new Date(todayStr);
    invalidDay.setDate(invalidDay.getDate() + 15);

    if(date.getTime() >= invalidDay.getTime()) {
      return true;
    } else {
      return false;
    }
  }

  isInsideThisPlan(dateTime: Date, start: Date, end: Date) {
    return (dateTime.getTime() >= start.getTime()) && (end.getTime() >= dateTime.getTime());
  }

  getStyle(level: number) {
    if(level >= 2) {
      return this.colorMap.get(2);
    } else {
      return this.colorMap.get(level);
    }
  }

  getRunDurationHours(flowcellName: string, largestReadMode: string) {
    let flowCellMap = this.flowCellDurationMap.get(flowcellName);
    let duration = flowCellMap ? flowCellMap[largestReadMode] : null;
    return duration ? duration : 0;
  }

  getDisplay(endDate: Date) {
    return this.datepipe.transform(endDate, this.selectableLab.lab.dateFormat +' HH:mm' );
  }

  calculateEndDateTime() {    
    this.selectedTimeSlotEnd = new Date(this.selectedTimeSlotStart);
    this.selectedTimeSlotEnd.setHours(this.selectedTimeSlotEnd.getHours() + this.selectedRunDuration);
    this.showSlotErrorMessage = false;
    this.slotValidated = false;
  }

  validateSlot() {
    this.slotValidated = true;
    if(!this.selectedRunDuration) {
      this.schedulingMessage = 'No duration found for this run.'
      this.showSlotErrorMessage = true;
      return;
    }

    if(new Date().getTime() > this.selectedTimeSlotStart.getTime()) {
      this.backUpRestore()
      this.schedulingMessage = 'This start date time is before the current time. Please choose a future date time. Selection has been reset'
      this.showSlotErrorMessage = true;
      return;
    }

    this.showSlotErrorMessage = false;
    let times = this.runPlans[this.selectedSequencer];
    if(times && times.length > 0) {
      
      for(let j = 0; j < times.length; j++) {
        this.getStartAndEndDate(times, j); 
      }
    } else {
      this.slotValidated = true;
    }

    if(this.slotValidated) {
      this.selectedTimeSlotStartBackup = new Date(this.selectedTimeSlotStart);
      this.selectedTimeSlotEndBackup = new Date(this.selectedTimeSlotEnd);
      this.selectedSequencerBackup = this.selectedSequencer + '';
      this.schedulingMessage = 'This timeslot is valid!';
      this.showSlotErrorMessage = true;
    } else {
      this.backUpRestore();
      this.schedulingMessage = 'This timeslot overlaps with an existing run. Selection has been reset.';
      this.showSlotErrorMessage = true;
    }
  }

 getStartAndEndDate(times: any, j: number) {
    let start : Date;
    let end : Date;

    start = new Date(times[j]['planDate']);
    end = new Date(times[j]['plannedFinishDate']);

    if (this.isInsideThisPlan(this.selectedTimeSlotStart, start, end) || this.isInsideThisPlan(this.selectedTimeSlotEnd, start, end)
      || this.planContainsPlan(this.selectedTimeSlotStart, this.selectedTimeSlotEnd, start, end)) {
      this.slotValidated = false;
    }
  }

 
  planContainsPlan(selectedStart: Date, selectedEnd: Date, startOfPlan: Date, endOfPlan: Date) {
    return ((selectedStart.getTime() <= startOfPlan.getTime()) && (selectedEnd.getTime() >= endOfPlan.getTime()));
  }

  backUpRestore() {
    this.selectedTimeSlotStart = new Date(this.selectedTimeSlotStartBackup);
    this.selectedTimeSlotEnd = new Date(this.selectedTimeSlotEndBackup);
    this.selectedSequencer = this.selectedSequencerBackup + '';
  }

  suggestSlotForMachine() {
    if(!this.selectedRunDuration) {
      this.schedulingMessage = 'No duration found for this run.'
      this.showSlotErrorMessage = true;
      return;
    }
    this.slotValidated = false;
    this.showSlotErrorMessage = false;
    this.selectedTimeSlotStart = null;
    this.selectedTimeSlotEnd = null;
    let startDateTime = new Date();
    startDateTime.setMinutes(startDateTime.getMinutes() + 5);
    let endDateTime = new Date(startDateTime);
    endDateTime.setHours(startDateTime.getHours() + this.selectedRunDuration);
    let times = this.runPlans[this.selectedSequencer];
    let returnObj = this.findSlot(times, startDateTime, endDateTime);
    this.slotValidated = returnObj.slotValidated;
    if(this.slotValidated) {
      this.selectedTimeSlotStart = new Date(returnObj.timeSlotStart);
      this.selectedTimeSlotStartBackup = new Date(this.selectedTimeSlotStart);
      this.selectedTimeSlotEnd = new Date(returnObj.timeSlotEnd);
      this.selectedTimeSlotEndBackup = new Date(this.selectedTimeSlotEnd);
      this.selectedSequencerBackup = this.selectedSequencer + '';
      this.schedulingMessage = 'This is the first timeslot found for this run on this machine.';
      this.showSlotErrorMessage = true;
    } else {
      this.backUpRestore();
      this.schedulingMessage = 'No suitable timeslot found for this run on this Machine in the next 15 days. Selection has been reset';
      this.showSlotErrorMessage = true;
      return;
    }
  }

  getFontColor() {
    return this.slotValidated ? { 'color': 'green' } : { 'color' : 'red' };
  }

  saveRun() {
    let runCopy = Object.assign({}, this.selectedRun);

    if(new Date().getTime() > this.selectedTimeSlotStart.getTime()) {
      this.schedulingMessage = 'This start date time is before the current time. Please choose a future date time.'
      this.showSlotErrorMessage = true;
    }

    let run = {
      'lab' : this.selectableLab.lab._id,
      'runId' : this.selectedRun['runId'],
      'status' : 'RUN_SCHEDULED',
      'sequencerIntrument' :  this.selectedSequencer,
      'planDate' : this.selectedTimeSlotStart.toISOString(),
      'plannedFinishDate' : this.selectedTimeSlotEnd.toISOString(),
      'scheduledPUID' : localStorage.getItem('PUID'),
      'scheduledDateTime' : new Date().toISOString(),
      'runDuration': this.selectedRunDuration
    };

    this.runPlanSchedulerService.saveRun(run).subscribe(
      _results => {
        this.showScheduleSideBar = false;
        this._messagesService.addSuccessMessage({severity : 'success', summary: 'Run '+ this.selectedRun['runId'] +' scheduled successfully!'});
        this.unscheduledTableData = this.unscheduledTableData.filter(run => run['runId'] != this.selectedRun['runId']);
        runCopy['status'] = 'RUN_SCHEDULED';
        runCopy['planDate'] = {'$date' : this.selectedTimeSlotStart.toISOString()};
        runCopy['plannedFinishDate'] = {'$date' : this.selectedTimeSlotEnd.toISOString()};
        runCopy['sequencerIntrument'] = this.selectedSequencer;
        runCopy['justScheduled'] = true;

        this.scheduledTableRunLaneMap.set(runCopy['runId'], this.unscheduledTableRunLaneMap.get(runCopy['runId']));
        this.scheduledTableData.push(runCopy);
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }


  getBorderStyle(run: any) {
    if(run['justScheduled']) {
      return {
        'border' : '2px solid #006B96'
      }
    }
  }

  isValidateDisabled() {
    if (!this.scheduleMatrix || (this.scheduleMatrix.length == 0) || !this.selectedTimeSlotStart || !this.selectedTimeSlotEnd || !this.machines || this.machines.length == 0) {
      return true;
    }

    return this.slotValidated;
  }

  isSaveDisabled() {
    if (!this.scheduleMatrix || (this.scheduleMatrix.length == 0) || !this.selectedTimeSlotStart || !this.selectedTimeSlotEnd || !this.machines || this.machines.length == 0) {
      return true;
    }

    return !this.slotValidated;
  }

  useMachineToSuggest(machine: string) {
    this.selectedSequencer = machine;
    this.suggestSlotForMachine();
  }

  useDayToVerify(startDateStr: string, machine: string) {
    let parts = startDateStr.split('-');
    startDateStr = parts[2] + '-' + parts[1] + '-' + parts[0];
    this.selectedTimeSlotStart = new Date(startDateStr);
    this.selectedTimeSlotStart.setHours(0);
    this.selectedTimeSlotStart.setMinutes(0);
    this.selectedTimeSlotStart.setSeconds(0);
    this.selectedTimeSlotStart.setMilliseconds(0);
    this.selectedSequencer = machine;
    this.calculateEndDateTime();
  }

  sortUnscheduledTableData(event: any) {
    let compResult = null;
    if (event.field  == 'flowcellConfig') {
      this.unscheduledTableData.sort((run1: any, run2: any) => {
        let runData1 = run1.flowCellName + " " + run1.largestReadMode ? run1.flowCellName + " " + run1.largestReadMode : '';
        let runData2 = run2.flowCellName + " " + run1.largestReadMode ? run2.flowCellName + " " + run1.largestReadMode : '';
        compResult = this.getSortResult(runData1, runData2);
        return (event.order * compResult);
      });
    } else if (event.field  == 'runDuration') {
      this.unscheduledTableData.sort((run1: any, run2: any) => {
        let runData1 = this.getRunDuration(run1.flowCellName, run1.largestReadMode) ? this.getRunDuration(run1.flowCellName, run1.largestReadMode) : '';
        let runData2 = this.getRunDuration(run2.flowCellName, run2.largestReadMode) ? this.getRunDuration(run2.flowCellName, run2.largestReadMode) : '';
        compResult = this.getSortResult(runData1, runData2);
        return (event.order * compResult);
      });
    } else if (event.field  == 'laneDetails') {
      this.unscheduledTableData.forEach(run => {
        run.lowestDueDate=0;
        run.runLanes.forEach(lane => {
          lane.runLanes.forEach(ipus => {
            if(run.lowestDueDate > ipus.dueDate){
              run.lowestDueDate=ipus.dueDate;
            }
          });
        });
      });
      this.unscheduledTableData.sort((rundata1: any, rundata2: any) => {
        let runLane1 = rundata1.lowestDueDate ? rundata1.lowestDueDate: '';
        let runLane2 = rundata2.lowestDueDate ? rundata2.lowestDueDate : '';
        compResult = this.getSortResult(runLane1, runLane2);
        return (event.order * compResult);
      });
    } else {
      this.unscheduledTableData.sort((run1: any, run2: any) => {
        let runData1 = run1[event.field ] ? run1[event.field ] : '';
        let runData2 = run2[event.field ] ? run2[event.field ] : '';
        compResult = this.getSortResult(runData1, runData2);
        return (event.order * compResult);
      });
    }
  }

  sortscheduledTableData(event: any) {
    let compResult = null;
    if (event.field == 'flowcellConfig') {
      this.scheduledTableData.sort((run1: any, run2: any) => {
        let runData1 = run1.flowCellName + " " + run1.largestReadMode ? run1.flowCellName + " " + run1.largestReadMode : '';
        let runData2 = run2.flowCellName + " " + run1.largestReadMode ? run2.flowCellName + " " + run1.largestReadMode : '';
        compResult = this.getSortResult(runData1, runData2);
        return (event.order * compResult);
      });
    } else if (event.field == 'laneDetails') {
      this.scheduledTableData.forEach(run => {
        run.lowestDueDate=0;
        run.runLanes.forEach(lane => {
          lane.runLanes.forEach(ipus => {
            if(run.lowestDueDate > ipus.dueDate){
              run.lowestDueDate=ipus.dueDate;
            }
          });
        });
      });
      this.scheduledTableData.sort((rundata1: any, rundata2: any) => {
        let runLane1 = rundata1.lowestDueDate ? rundata1.lowestDueDate: '';
        let runLane2 = rundata2.lowestDueDate ? rundata2.lowestDueDate : '';
        compResult = this.getSortResult(runLane1, runLane2);
        return (event.order * compResult);
      });
    } else if (event.field == 'planDate' || event.field == 'plannedFinishDate') {
      if (event.order == 1) {
        this.scheduledTableData.sort((run1, run2) => {
          let dateA:any
          let dateB:any
           dateA = run1[event.field] && run1[event.field]['$date'] ? new Date(run1[event.field]['$date']).getTime() : '';
          dateB = run2[event.field] && run2[event.field]['$date'] ? new Date(run2[event.field]['$date']).getTime(): '' ;
          return dateB - dateA;
        })
      }else{
        this.scheduledTableData.sort((run1, run2) => {
          let dateA:any
          let dateB:any
           dateA = run1[event.field] && run1[event.field]['$date'] ? new Date(run1[event.field]['$date']).getTime() : '' ;
          dateB = run2[event.field] && run2[event.field]['$date'] ? new Date(run2[event.field]['$date']).getTime(): '';
          return dateA - dateB;
        })
      }
     } else {
      this.scheduledTableData.sort((run1: any, run2: any) => {
        let runData1 = run1[event.field] ? run1[event.field] : '';
        let runData2 = run2[event.field] ? run2[event.field] : '';
        compResult = this.getSortResult(runData1, runData2);
        return (event.order * compResult);
      });
    }
  }
  getSortResult(value1, value2) {
    if (value1 < value2) {
      return -1;
    }
    return (value1 > value2) ? 1 : 0;
  }
  unScheduleGlobalFilter(value: any) {
    if (value) {
      this.unscheduledTableData=this.globalFilter(this.unscheduledTableDataDuplicate, value)
    } else {
      this.getUnscheduledTableData();
    }
  }
  scheduleGlobalFilter(value: any) {
    if (value) {
      this.scheduledTableData = this.globalFilter(this.scheduledTableDataDuplicate, value);
    } else {
      this.getScheduledTableData();
    }
  }

  globalFilter(itemList: any, searchKeyword: string) {
    let filteredList = [];
    let filteredListforLane = [];
    if (itemList.length > 0) {
      searchKeyword = searchKeyword.toLowerCase();
      itemList.forEach(item => {
        let propValueList = Object.values(item);
        for (let i = 0; i < propValueList.length; i++) {
          let duration = this.getRunDuration(item.flowCellName, item.largestReadMode)
          if (duration && duration.toString().toLowerCase().indexOf(searchKeyword) > -1) {
            filteredList.push(item);
            break;
          }
          if(item){
            let flowcellConfig= item.flowCellName + " " + item.largestReadMode;
            if (flowcellConfig && flowcellConfig.toString().toLowerCase().indexOf(searchKeyword) > -1) {
              filteredList.push(item);
              break;
            }
          }
          if (item.planDate) {
            let date = this.getDate(item.planDate);
            if (date && date.toString().toLowerCase().indexOf(searchKeyword) > -1) {
              filteredList.push(item);
              break;
            }
          }
          if (propValueList[i]) {
            if (!Array.isArray(propValueList[i]) && propValueList[i].toString().toLowerCase().indexOf(searchKeyword) > -1) {
              filteredList.push(item);
              break;
            } else if (Array.isArray(propValueList[i])) {
              let runLanesListData = Object.values(propValueList[i]);
              for (let prop of runLanesListData) {
                if(prop != null){
                if (prop.laneId.toString().toLowerCase().indexOf(searchKeyword) > -1 ||  prop.runLanes.length > 0 && prop.runLanes[0].constraintId.toString().toLowerCase().indexOf(searchKeyword) > -1) {
                  filteredListforLane.push(item);
                  break;
                 }
                }
              }
            }
          }
        }
      });
      filteredListforLane.forEach(element => {
        if (!filteredList.some(filter => filter.runId === element.runId)) {
          filteredList.push(element);
        }
      });
      return filteredList;
    }
  }

  paginateForUnscheduled(event) {
    if (event.page != 0) {
      this.pageNumber = event.page + 1;
      this.pageSkip = (this.pageNumber-1) * 40;
      let request = {
        'lab': this.selectableLab.lab._id,
        'statusList': ['RUN_PLANNED'],
        'sequencerType': this.selectedSequencerType,
        'page': this.pageNumber,
        'skip': this.pageSkip,
        'limit': this.pageLimit
      }
      this.getUnscheduledAPiCall(request);
    }else{
      this.getUnscheduledTableData();
    }
  }

  paginateForscheduled(event){
    if (event.page != 0) {
      this.schduledpageNumber = event.page + 1;
      this.schduledpageSkip=(this.schduledpageNumber-1) * 40;
      let request = {
        'lab': this.selectableLab.lab._id,
        'statusList': this.SCHEDULED_TABLE_FILTER_STATUS,
        'sequencerType': this.selectedSequencerType,
        'page': this.schduledpageNumber,
        'skip': this.schduledpageSkip,
        'limit': this.schduledpageLimit,
        'startDate': this.scheduledFromDate.toISOString(),
        'finishDate': this.scheduledToDate.toISOString()
      };
      this.getscheduledAPiCall(request);
    }else{
      this.getScheduledTableData();
    }
  }
}
